import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isCategoryIncludesExpert } from "@/components/Package/getPassScope";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button } from "@bookips/sds";
const EXPERT_GUIDE_URL = "https://solvookguide.oopy.io/expert";
const DEFAULT_GUIDE_URL = "https://solvookguide.oopy.io/waytouse";
const PassInfoDialogFooter = (param)=>{
    let { pass , membershipId , mode , position , primaryLabel , onPrimary , onUsageGuide  } = param;
    var _pass_guideButtonUrl;
    // BE 응답값 우선. null/undefined/빈 문자열·공백 모두 fallback 으로 처리.
    const guideUrl = ((_pass_guideButtonUrl = pass.guideButtonUrl) === null || _pass_guideButtonUrl === void 0 ? void 0 : _pass_guideButtonUrl.trim()) || (isCategoryIncludesExpert(pass.category) ? EXPERT_GUIDE_URL : DEFAULT_GUIDE_URL);
    const resolvedPrimaryLabel = primaryLabel !== null && primaryLabel !== void 0 ? primaryLabel : mode === "purchase" ? "구매하기" : "확인";
    // MX-597 — 구매 컨텍스트를 제외한 보유·구독 컨텍스트에서 다이얼로그 내 버튼 클릭 시 발사.
    // 구매는 호출처가 'Purchase Button Clicked' 로 별도 추적하므로 중복 발사하지 않는다.
    const trackPopupButton = (buttonName, buttonUrl)=>{
        if (mode === "purchase") return;
        mixpanelEvent("Popup Button Clicked", {
            Position: position,
            "Popup Type": "이용권 상세 다이얼로그",
            "Popup Title": pass.title,
            "Button Name": buttonName,
            "Button URL": buttonUrl,
            "Membership Product Id": pass.id,
            "Membership Id": membershipId,
            "Membership Category": pass.category
        });
    };
    const handleUsageGuide = ()=>{
        trackPopupButton("이용방법 보기", guideUrl);
        if (onUsageGuide) {
            onUsageGuide();
            return;
        }
        window.open(guideUrl, "_blank", "noopener,noreferrer");
    };
    const handlePrimary = ()=>{
        trackPopupButton(resolvedPrimaryLabel);
        onPrimary();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-2 px-7 pt-5 pb-5 max-sm:px-5 max-sm:pt-4 max-sm:pb-4 [&>button]:w-full",
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "secondary",
                size: "lg",
                onClick: handleUsageGuide,
                children: "이용방법 보기"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "fill",
                color: "primary",
                size: "lg",
                onClick: handlePrimary,
                children: resolvedPrimaryLabel
            })
        ]
    });
};
export default PassInfoDialogFooter;
